<template>
    <div>

        <!-- 点击 Report information errors 后弹出 -->
        <!-- reportDialog -->
        <el-dialog :visible.sync="reportDialog" center :close-on-click-modal="true"   :append-to-body="true"
            @close="cancelDialog"
            custom-class="dialog_normal2" style="margin-top: -50px">
            <div class="agreement_cont">
                <el-tabs :tab-position="window.innerWidth < 821 ? 'top' : 'left'">
                    <el-tab-pane label="Privacy Policy">
                        <div style="margin-left: 1.4285em">
                            <h1 class="info1">Privacy Policy</h1>
                            <br />
                            <br />
                            <br />
                            <div class="info1box">
                                <div>Our Privacy Policy is designed to assist you in understanding how we collect and
                                    use the personal information you provide to us and to assist you in making informed
                                    decisions when using our site and our products and services.</div>
                                <br />

                                <h2 class="question">What Information Do We Collect?</h2>

                                <br />
                                <div>When you visit our website, you may provide us with two types of information:
                                    personal information you knowingly choose to disclose that is collected on an
                                    individual basis and Website use information collected on an aggregate basis as you
                                    and others browse our website.</div>
                                <br />
                                <br />
                                <span class="answer-title">1. Personal Information You Choose to Provide</span>
                                <br />
                                <br />
                                <div class="answer-content">
                                    <span class="answer-title-italic">Registration Information.</span>
                                    <br />
                                    <br />
                                    <span>When you visit our website, you may provide us with two types of information:
                                        personal information you knowingly choose to disclose that is collected on an
                                        individual basis and Website use information collected on an aggregate basis as
                                        you and others browse our website.</span>
                                    <br />
                                    <br />
                                    <span class="answer-title-italic">Email Information.</span>
                                    <br />
                                    <br />
                                    <span>If you choose to correspond with us through email, we may retain the content
                                        of your email messages together with your email address and our
                                        responses.</span>
                                    <br />
                                    <br />
                                    <br />
                                </div>
                                <span class="answer-title">2. Website Use Information</span>
                                <div class="answer-content">
                                    <br />
                                    <span>Similar to other commercial websites, our website utilizes a standard
                                        technology called "cookies" (see explanation below, "What Are Cookies?") and Web
                                        server logs to collect information about how our website is used. Information
                                        gathered through cookies and Web server logs may include the date and time of
                                        visits, the pages viewed, time spent at our website, and the Websites visited
                                        just before and just after our website. We, our advertisers and ad serving
                                        companies may also use small technology or pieces of code to determine which
                                        advertisements and promotions users have seen and how users responded to
                                        them.</span>
                                    <br />
                                    <br />
                                    <br />
                                </div>
                                <h2 class="question">How Do We Use the Information That You Provide to Us?</h2>
                                <br />
                                <span>Broadly speaking, we use personal information for purposes of administering and
                                    expanding our business activities, providing customer service and making available
                                    other products and services to our customers and prospective customers.
                                    Occasionally, we may also use the information we collect to notify you about
                                    important changes to our website, new services and special offers we think you will
                                    find valuable. You may notify us at any time if you do not wish to receive these
                                    updates and/or offers by emailing us at</span>
                                <div><a href="mailto:request@CSIbizInfo.com"
                                        class="amail-style">request@CSIbizInfo.com.</a></div>
                                <br />
                                <h2 class="question">What Are Cookies?</h2>
                                <br />
                                <span>A cookie is a very small text document, which often includes an anonymous unique
                                    identifier. When you visit a website, that site's computer asks your computer for
                                    permission to store this file in a part of your hard drive specifically designated
                                    for cookies. Each Website can send its own cookie to your browser if your browser's
                                    preferences allow it, but (to protect your privacy) your browser only permits a
                                    Website to access the cookies it has already sent to you, not the cookies sent to
                                    you by other sites. Some of our business partners (e.g., advertisers) use cookies
                                    that originate from their sites. We have no access or control over those
                                    cookies.</span>
                                <br />
                                <br />
                                <h2 class="question">How Do We Use Information We Collect from Cookies?</h2>
                                <br />
                                <span>As you use our website, the site uses its cookies to differentiate you from other
                                    users. In some cases, we also use cookies to prevent you from seeing unnecessary
                                    advertisements or requiring you to log in more than once for security reasons.
                                    Cookies, in conjunction with our Web server's log files, allow us to calculate the
                                    aggregate number of people visiting our website and which parts of the site are most
                                    popular. This helps us gather feedback in order to constantly improve our website
                                    and better serve our customers. Cookies do not allow us to gather any personal
                                    information about you and we do not generally store any personal information that
                                    you provided to us in your cookies.</span>
                                <br />
                                <br />
                                <div class="answer-content">
                                    <span class="answer-title">Sharing Information with Third Parties</span>
                                    <br />
                                    <br />
                                    <span>
                                        We may enter into alliances, partnerships or other business arrangements with
                                        third parties who may be given access to personal information including your
                                        name, address, telephone number and email for the purpose of providing you
                                        information regarding products and services that we think will be of interest to
                                        you. In connection with alliances, partnerships or arrangements, we may also
                                        provide certain information to third parties if we have determined that the
                                        information will be used in a responsible manner by a responsible third party.
                                        For example, some of our partners operate stores or provide services on our
                                        site, while others power offerings developed by us for your use. We also use
                                        third parties to facilitate our business, including, but not
                                        limited to, sending email and processing credit card payments. In connection
                                        with these offerings and business operations, our partners and other third
                                        parties may have access to your personal information for use in connection with
                                        the business activities. As we develop our business, we may buy or sell assets
                                        or business offerings. Customer, email, and visitor information is generally one
                                        of the transferred business assets in these types of transactions. We may also
                                        transfer such information in the course of corporate divestitures, mergers, or
                                        any dissolution.
                                    </span>
                                    <br />
                                    <br />
                                    <span class="answer-title">Notice of New Services and Changes</span>
                                    <br />
                                    <br />
                                    <span>Occasionally, we may also use the information we collect to notify you about
                                        important changes to our website, new services and special offers we think you
                                        will find valuable. As our customer, you will be given the opportunity to notify
                                        us if you would not like to receive these offers, by sending us an email request
                                        at</span>
                                    <div><a href="mailto:request@CSIbizInfo.com"
                                            class="amail-style">request@CSIbizInfo.com.</a></div>
                                    <br />
                                    <br />
                                </div>
                                <h2 class="question">How Do We Secure Information Transmissions?</h2>
                                <br />
                                <span>Email is not recognized as a secure medium of communication. For this reason, we
                                    request that you do not send private information to us by email. Some of the
                                    information you may enter on our website may be transmitted securely via Secure
                                    Sockets Layer SSL, 128-bit encryption services. Pages utilizing this technology will
                                    have URLs that start with HTTPS instead of HTTP. Please contact</span>
                                <div>
                                    <a href="mailto:request@CSIbizInfo.com"
                                        class="amail-style">request@CSIbizInfo.com.</a>
                                    <span>if you have any questions or concerns.</span>
                                </div>
                                <br />
                                <h2 class="question">How Can You Access and Correct Your Information?</h2>
                                <br />
                                <span>You may request access to all your personally identifiable information that we
                                    collect online and maintain in our database by emailing</span>
                                <div><a href="mailto:request@CSIbizInfo.com"
                                        class="amail-style">request@CSIbizInfo.com.</a></div>
                                <br />
                                <div class="answer-content">
                                    <span class="answer-title">Certain Disclosures</span>
                                    <br />
                                    <br />
                                    <span>We may disclose your personal information if required to do so by law or
                                        subpoena or if we believe that such action is necessary to (a) conform to the
                                        law or comply with legal process served on us or affiliated parties; (b) protect
                                        and defend our rights and property, our site, the users of our site, and/or our
                                        affiliated parties; (c) act under circumstances to protect the safety of users
                                        of our site, us, or third parties.</span>
                                </div>
                                <br />
                                <br />
                                <h2 class="question">What About Other Websites Linked to Our Website?</h2>
                                <br />
                                <span>We are not responsible for the practices employed by Websites linked to or from
                                    our website nor the information or content contained therein. Often links to other
                                    Websites are provided solely as pointers to information on topics that may be useful
                                    to the users of our website.</span>
                                <br />
                                <br />
                                <span>Please remember that when you use a link to go from our Website to another
                                    Website, our Privacy Policy is no longer in effect. Your browsing and interaction on
                                    any other Website, including Websites which have a link on our Website, is subject
                                    to that Website's own rules and policies. Please read those rules and policies
                                    before proceeding.</span>
                                <br />
                                <br />
                                <div class="answer-content">
                                    <span class="answer-title">Your Consent</span>
                                    <br />
                                    <br />
                                    <span>By using our website, you consent to our collection and use of your personal
                                        information as described in this Privacy Policy. If we change our privacy
                                        policies and procedures, we will post those changes on our website to keep you
                                        aware of what information we collect, how we use it and under what circumstances
                                        we may disclose it.</span>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="Terms of Use Agreement">
                        <div style="margin-left: 1.4285em">
                            <h1 class="info1">Terms of Use Agreement</h1>
                            <br />
                            <br />
                            <br />
                            <div class="info1box">
                                <div>By using our site, you are agreeing to comply with and be bound by the following
                                    terms of use. Please review the following terms carefully. If you do not agree to
                                    these terms, you should not use this site. The term ‘CSIbizInfo’ or “us” or “we” or
                                    “our” refers to ‘Company Search Incorporated’, the owner of the Website. The term
                                    “you” refers to the user or viewer of our website.</div>
                                <br />

                                <h2 class="question">Acceptance of Agreement</h2>

                                <br />
                                <div>You agree to the terms and conditions outlined in this Terms of Use Agreement
                                    ("Agreement") with respect to our website (the "Site"). This Agreement constitutes
                                    the entire and only agreement between us and you, and supersedes all prior or
                                    contemporaneous agreements, representations, warranties and understandings with
                                    respect to the Site, the content, products or services provided by or through the
                                    Site, and the subject matter of this Agreement. This Agreement may be amended at any
                                    time, at our absolute discretion, from time to time without specific notice to you.
                                    The latest Agreement will be posted on the Site, and you should review this
                                    Agreement prior to using the Site.</div>
                                <br />
                                <br />

                                <h2 class="question">Service Marks</h2>
                                <br />
                                <span>‘CSIbizInfo.com’ and others are our service marks, registered service marks or
                                    trademarks. Other product and company names mentioned on the Site may be trademarks
                                    of their respective owners.</span>
                                <br />
                                <br />
                                <h2 class="question">Limited License; Permitted Uses</h2>
                                <br />
                                <span>You are granted a non-exclusive, non-transferable, revocable license (a) to access
                                    and use the Site strictly in accordance with this Agreement; (b) to use the Site
                                    solely for internal, personal, non-commercial purposes; and (c) to print out
                                    discrete information (or electronic version) from the Site solely for internal,
                                    personal, non-commercial purposes and provided that you maintain all copyright and
                                    other policies contained therein. No print out or electronic version of any part of
                                    the Site or its contents may be used by you in any litigation or arbitration matter
                                    whatsoever under any circumstances.</span>
                                <br />
                                <br />
                                <h2 class="question">Restrictions and Prohibitions on Use</h2>
                                <br />
                                <span>
                                    Your license for access and use of the Site and any information, materials or
                                    documents (collectively defined as “Content and Materials”) therein are subject to
                                    the following restrictions and prohibitions on use: You may not (a) copy, print
                                    (except for the express limited purpose permitted above), republish, display,
                                    distribute, transmit, sell, rent, lease, loan or otherwise make available in any
                                    form or by any means all or any portion of the Site or any Content and Materials
                                    retrieved there from; (b) use the Site or any materials obtained from the Site to
                                    develop, of as a component of, any information, storage and retrieval system,
                                    database, information base, or similar resource (in any media now existing or
                                    hereafter developed), that is offered for
                                    commercial distribution of any kind, including through sale, license, lease, rental,
                                    subscription, or any other commercial distribution mechanism; (c) create
                                    compilations or derivative works of any Content and Materials from the Site; (d) use
                                    any Content and Materials from the Site in any manner that may infringe any
                                    copyright, intellectual property right, proprietary right, or property right of us
                                    or any third parties; (e) remove, change or obscure any copyright notice or other
                                    proprietary notice or terms of use contained in the Site; (f) make any portion of
                                    the Site available through any timesharing system, service bureau, the Internet or
                                    any other technology now existing or developed in the future; (g) remove, decompile,
                                    disassemble or reverse
                                    engineer any Site software or use any network monitoring or discovery software to
                                    determine the Site architecture; (h) use any automatic or manual process to harvest
                                    information from the Site; (i) use the Site for the purpose of gathering information
                                    for or transmitting (1) unsolicited commercial email; (2) email that makes use of
                                    headers, invalid or nonexistent domain names, or other means of deceptive
                                    addressing; and (3) unsolicited telephone calls or facsimile transmissions; (j) use
                                    the Site in a manner that violates any state or federal law regulating email,
                                    facsimile transmissions or telephone solicitations; and (k) export or re-export the
                                    Site or any portion thereof, or any software available on or through the Site.
                                </span>
                                <br />
                                <br />

                                <h2 class="question">Forms, Agreements & Documents</h2>
                                <br />
                                <span>
                                    We may make available through the Site or through other Websites sample and actual
                                    forms, checklists, business documents and legal documents (collectively,
                                    “Documents”). All Documents are provided on a non-exclusive license basis only for
                                    your personal one-time use for non-commercial purposes, without any right to
                                    re-license, sublicense, distribute, assign or transfer such license. Documents are
                                    provided for a charge and without any representations or warranties, express or
                                    implied, as to their suitability, legal effect, completeness, currentness, accuracy,
                                    and/or appropriateness. The Documents are provided “as is”, “as available”, and with
                                    “all faults”, and we and any provider of the Documents disclaim any warranties,
                                    including but not limited to the
                                    warranties of merchantability and fitness for a particular purpose. The Documents
                                    may be inappropriate for your particular circumstances. Furthermore, state or
                                    provincial laws may require different or additional provisions to ensure the desired
                                    result. You should consult with legal counsel to determine the appropriate legal or
                                    business documents necessary for your particular transactions, as the Documents are
                                    only samples and may not be applicable to a particular situation. Some Documents are
                                    public domain forms or available from public records.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">No Legal Advice or Attorney-Client Relationship</h2>
                                <br />
                                <span>Information contained on or made available through the Site is not intended to and
                                    does not constitute legal advice, recommendations, mediation or counseling under any
                                    circumstance and no attorney-client relationship is formed. We do not warrant or
                                    guarantee the accurateness, completeness, adequacy or currentness of the information
                                    contained in or linked to the Site. Your use of information on the Site or materials
                                    linked to the Site is entirely at your own risk. We are not a law firm and the Site
                                    is not a lawyer referral service.</span>

                                <br />
                                <br />
                                <h2 class="question">Linking to the Site</h2>
                                <br />
                                <span>You may provide links to the Site, provided (a) that you do not remove or obscure,
                                    by framing or otherwise, advertisements, the copyright notice, or other notices on
                                    the Site, (b) your site does not engage in illegal or pornographic activities, and
                                    (c) you discontinue providing links to the Site immediately upon request by
                                    us.</span>
                                <br />
                                <br />
                                <h2 class="question">Advertisers</h2>
                                <br />
                                <span>The Site may contain advertising and sponsorships. Advertisers and sponsors are
                                    responsible for ensuring that material submitted for inclusion on the Site is
                                    accurate and complies with applicable laws. We are not responsible for the
                                    illegality or any error, inaccuracy or problem in the advertiser’s or sponsor’s
                                    materials.</span>
                                <br />
                                <br />
                                <h2 class="question">Registration</h2>
                                <br />
                                <span>Certain sections of, or offerings from, the Site may require you to register. If
                                    registration is requested, you agree to provide us with accurate, complete
                                    registration information. Your registration must be done using your real name and
                                    accurate information. Each registration is for your personal use only and not on
                                    behalf of any other person or entity. We do not permit: (a) any other person using
                                    the registered sections under your name; or (b) access through a single name being
                                    made available to multiple users on a network. You are responsible for preventing
                                    such unauthorized use and can be held accountable.</span>
                                <br />
                                <br />
                                <span>It is prohibited and, consequently, punishable by law when the user gives false
                                    personal details, if registering at the website or other ways of
                                    communication.</span>
                                <br />
                                <br />
                                <h2 class="question">Database:</h2>
                                <br />
                                <span>We source the information in our databases through a variety of means including:
                                    directly from government websites, from publicly available datasets, through Freedom
                                    of Information requests as well as data partners, with or without APIs. All of the
                                    data is converted into a usable resource enabling the user an easy workable search
                                    engine search engine We spend a lot of time, effort, and even money in getting this
                                    data and turning it into a usable resource workable and highly usable
                                    resource.</span>
                                <br />
                                <br />
                                <span>We do not claim any rights over the information we receive from our any of our
                                    sources, though claim rights over our database of this information.</span>
                                <br />
                                <br />
                                <h2 class="question">Availability of Products</h2>
                                <br />
                                <span>Access and/or Information on the Site might not be available in your location. If
                                    that occurs, it has to do with local laws and prohibitions. When that is the case,
                                    please contact</span>
                                <a href="mailto:request@CSIbizInfo.com" class="amail-style">request@CSIbizInfo.com.</a>
                                for more information.
                                <br />
                                <br />

                                <h2 class="question">Errors, Corrections and Changes</h2>
                                <br />
                                <span>We do not represent or warrant that the Site will be error-free, free of viruses
                                    or other harmful components, or that defects will be corrected. We do not represent
                                    or warrant that the information available on or through the Site will be correct,
                                    accurate, timely or otherwise reliable. We may make changes to the features,
                                    functionality or content of the Site at any time. We reserve the right in our sole
                                    discretion to edit or delete any documents, information or other content appearing
                                    on the Site.</span>
                                <br />
                                <br />
                                <h2 class="question">Third Party Content</h2>
                                <br />
                                <span>Third party content may appear on the Site or may be accessible via links from the
                                    Site. We are not responsible for and assume no liability for any mistakes,
                                    misstatements of law, defamation, omissions, falsehood, obscenity, pornography or
                                    profanity in the statements, opinions, representations or any other form of content
                                    on the Site. You understand that the information and opinions in the third-party
                                    content represent solely the thoughts of the author and is neither endorsed by nor
                                    does it necessarily reflect our belief.</span>
                                <br />
                                <br />
                                <h2 class="question">Unlawful Activity</h2>
                                <br />
                                <span>We reserve the right to investigate complaints or reported violations of this
                                    Agreement and to take any action we deem appropriate, including but not limited to
                                    reporting any suspected unlawful activity to law enforcement officials, regulators,
                                    or other third parties and disclosing any information necessary or appropriate to
                                    such persons or entities relating to your profile, email addresses, usage history,
                                    posted materials, IP addresses and traffic information.</span>
                                <br />
                                <span>The user should not to do anything to harm CSIbizInfo’s reputation.</span>
                                <br />
                                <br />
                                <h2 class="question">Indemnification</h2>
                                <br />
                                <span>The user agrees to indemnify, defend and hold us and our partners, agents,
                                    officers, directors, employees, subcontractors, successors, assigns, third party
                                    suppliers of information and documents, attorneys, advertisers, product and service
                                    providers, and affiliates (collectively, "Affiliated Parties") harmless from any
                                    liability, loss, claim and expense, including reasonable attorney's fees, related to
                                    your violation of this Agreement or use of the Site.</span>
                                <br />
                                <br />
                                <h2 class="question">Nontransferable</h2>
                                <br />
                                <span>Your right to use the Site is not transferable or assignable. Any password or
                                    right given to you to obtain information or documents is not transferable or
                                    assignable.</span>
                                <br />
                                <br />
                                <h2 class="question">Limitation of Liability</h2>
                                <br />
                                <span>(a) We and any Affiliated Party shall not be liable for any loss, injury, claim,
                                    liability, or damage of any kind resulting in any way from (a) any errors in or
                                    omissions from the Site or any services or products obtainable there from, (b) the
                                    unavailability or interruption of the Site or any features thereof, (c) your use of
                                    the Site, (d) the content contained on the Site, or (e) any delay or failure in
                                    performance beyond the control of a Covered Party.</span>
                                <br />
                                <br />
                                <span>(b) The aggregate liability of us and the affiliated parties in connection with
                                    any claim arising out of or relating to the site and/or the products, information,
                                    documents and services provided herein or hereby shall not exceed USD100. And that
                                    amount shall be in lieu of all other remedies which you may have against us and any
                                    affiliated party.</span>
                                <br />
                                <br />
                                <h2 class="question">Use of Information</h2>
                                <br />
                                <span>
                                    We reserve the right, and you authorize us, to the use and assignment of all
                                    information regarding Site uses by you and all information provided by you in any
                                    manner consistent with our Privacy Policy. All remarks, suggestions, ideas,
                                    graphics, or other information communicated by you to us (collectively, a
                                    "Submission") will forever be our property. We will not be required to treat any
                                    Submission as confidential, and will not be liable for any ideas (including without
                                    limitation, product, service or advertising ideas) and will not incur any liability
                                    as a result of any similarities that may appear in our future products, services or
                                    operations. Without limitation, we will have exclusive ownership of all present and
                                    future existing rights to the
                                    Submission of every kind and nature everywhere. We will be entitled to use the
                                    Submission for any commercial or other purpose whatsoever, without compensation to
                                    you or any other person sending the Submission. You acknowledge that you are
                                    responsible for whatever material you submit, and you, not us, have full
                                    responsibility for the message, including its legality, reliability,
                                    appropriateness, originality, and copyright.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">Third-Party Services</h2>
                                <br />
                                <span>
                                    We reserve the right, and you authorize us, to the use and assignment of all
                                    information regarding Site uses by you and all information provided by you in any
                                    manner consistent with our Privacy Policy. All remarks, suggestions, ideas,
                                    graphics, or other information communicated by you to us (collectively, a
                                    "Submission") will forever be our property. We will not be required to treat any
                                    Submission as confidential, and will not be liable for any ideas (including without
                                    limitation, product, service or advertising ideas) and will not incur any liability
                                    as a result of any similarities that may appear in our future products, services or
                                    operations. Without limitation, we will have exclusive ownership of all present and
                                    future existing rights to the
                                    Submission of every kind and nature everywhere. We will be entitled to use the
                                    Submission for any commercial or other purpose whatsoever, without compensation to
                                    you or any other person sending the Submission. You acknowledge that you are
                                    responsible for whatever material you submit, and you, not us, have full
                                    responsibility for the message, including its legality, reliability,
                                    appropriateness, originality, and copyright.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">Third-Party Merchant Policies</h2>
                                <br />
                                <span>All rules, policies (including privacy policies) and operating procedures of
                                    Merchants will apply to you while on any Merchant sites. We are not responsible for
                                    information provided by you to Merchants. We and the Merchants are independent
                                    contractors and neither party has authority to make any representations or
                                    commitments on behalf of the other.</span>
                                <br />
                                <br />
                                <h2 class="question">Privacy Policy</h2>
                                <br />
                                <span>Our Privacy Policy is designed to assist you in understanding how we collect and
                                    use the personal information you provide to us and to assist you in making informed
                                    decisions when using our site and our products and services. The user can only
                                    access or request personal data when he/she/they have a lawful basis for doing so.
                                    The user has to be able to demonstrate the existence of that lawful basis.</span>
                                <br />
                                <br />
                                <h2 class="question">Payments</h2>
                                <br />
                                <span>You represent and warrant that if you are purchasing something from us or from
                                    Merchants that (i) any credit information you supply is true and complete, (ii)
                                    charges incurred by you will be honored by yourself or your credit card company, and
                                    (iii) you will pay the charges incurred by you at the posted prices, including any
                                    applicable taxes.</span>
                                <br />
                                <br />
                                <span>When the user fails to pay the amount due, the full amount will become due with
                                    immediate effect and any remaining credits will be frozen until the amount has been
                                    settled.</span>
                                <br />

                                <br />
                                <span>The user shall be liable to pay interest on the basis of 3% above the prime annual
                                    base lending rate of the Bank of America. The user agrees to fully indemnify
                                    “CSIbizInfo” against all third-party cost incurred in the pursuit of payment. This
                                    includes any additional bank charges.</span>
                                <br />
                                <br />
                                <h2 class="question">Securities Laws</h2>
                                <br />
                                <span>
                                    The Site may include statements concerning our operations, prospects, strategies,
                                    financial condition, future economic performance and demand for our products or
                                    services, as well as our intentions, plans and objectives (particularly with respect
                                    to product and service offerings), that are forward-looking statements. These
                                    statements are based upon a number of assumptions and estimates which are subject to
                                    significant uncertainties, many of which are beyond our control. When used on our
                                    Site, words like "anticipates," "expects," "believes," "estimates," "seeks,"
                                    "plans," "intends," "will" and similar expressions are intended to identify
                                    forward-looking statements designed to fall within securities law safe harbors for
                                    forward-looking statements. The Site
                                    and the information contained herein do not constitute an offer or a solicitation of
                                    an offer for sale of any securities. None of the information contained herein is
                                    intended to be, and shall not be deemed to be, incorporated into any of our
                                    securities-related filings or documents.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">Links to other Websites</h2>
                                <br />
                                <span>The Site contains links to other Websites. We are not responsible for the content,
                                    accuracy or opinions express in such Websites, and such Websites are not
                                    investigated, monitored or checked for accuracy or completeness by us. Inclusion of
                                    any linked Website on our Site does not imply approval or endorsement of the linked
                                    website by us. If you decide to leave our Site and access these third-party sites,
                                    you do so at your own risk.</span>
                                <br />
                                <br />
                                <h2 class="question">Copyrights and Copyright Agents</h2>
                                <br />
                                <span>We respect the intellectual property of others, and we ask you to do the same. If
                                    you believe that your work has been copied in a way that constitutes copyright
                                    infringement, please provide our Copyright Agent the following information:</span>
                                <br />
                                <br />
                                <ul class="answer-ul">
                                    <li>
                                        <span style="width: 25px">1.</span>
                                        <span>An electronic or physical signature of the person authorized to act on
                                            behalf of the owner of the copyright interest;</span>
                                    </li>
                                    <li>
                                        <span style="width: 25px">2.</span>
                                        <span>A description of the copyrighted work that you claim has been
                                            infringed;</span>
                                    </li>
                                    <li>
                                        <span style="width: 25px">3.</span>
                                        <span>A description of where the material that you claim is infringing is
                                            located on the Site;</span>
                                    </li>
                                    <li>
                                        <span style="width: 25px">4.</span>
                                        <span>Your address, telephone number, and email address;</span>
                                    </li>
                                    <li>
                                        <span style="width: 25px">5.</span>
                                        <span>A statement by you that you have a good faith belief that the disputed use
                                            is not authorized by the copyright owner, its agent, or the law; and</span>
                                    </li>
                                    <li>
                                        <span style="width: 25px">6.</span>
                                        <span>A statement by you, made under penalty of perjury, that the above
                                            information in your Notice is accurate and that you are the copyright owner
                                            or authorized to act on the copyright owner's behalf.</span>
                                    </li>
                                </ul>
                                <br />
                                <br />
                                <span>Our Copyright Agent for Notice of claims of copyright infringement on the Site can
                                    be reached by directing an e-mail to the Copyright Agent at</span>
                                <a href="mailto:request@CSIbizInfo.com" class="amail-style">request@CSIbizInfo.com.</a>
                                for more information.
                                <br />
                                <br />
                                <h2 class="question">Information and Press Releases</h2>
                                <br />
                                <span>The Site contains information and press releases about us. We disclaim any duty or
                                    obligation to update this information or any press releases. Information about
                                    companies other than ours contained in the press release or otherwise, should not be
                                    relied upon as being provided or endorsed by us.</span>
                                <br />
                                <br />
                                <h2 class="question">Legal Compliance</h2>
                                <br />
                                <span>You agree to comply with all applicable domestic and international laws, statutes,
                                    ordinances and regulations regarding your use of the Site and the Content and
                                    Materials provided therein.</span>
                                <br />
                                <br />
                                <h2 class="question">Refund and Return Policy</h2>
                                <br />
                                <span>To the extent that you purchase any goods or services directly from us, we will
                                    refund you your purchase price within 30 days of you notifying us in writing of your
                                    desire for the refund, together with the reason for the request, with the product or
                                    service returned to us in substantially the same condition as when purchased. Please
                                    note, however, that certain products and services mentioned on our site are sold by
                                    third parties or are linked to third party websites, and we have no responsibility
                                    or liability for those products or services. You may request a refund by contacting
                                    us by email at</span>
                                <a href="mailto:request@CSIbizInfo.com" class="amail-style">request@CSIbizInfo.com.</a>
                                <span>You may obtain any additional information concerning our refund and return policy,
                                    including our mailing address, by contacting us at</span>
                                <a href="mailto:request@CSIbizInfo.com" class="amail-style">request@CSIbizInfo.com.</a>
                                <br />
                                <br />
                                <h2 class="question">Warning Regarding Web Fraud and Phishing:</h2>
                                <br />
                                <span>Our name, brand(s) and reputation may be misused or abused by imposters, fake
                                    websites and those engaging in “phishing” scams, seeking personal or confidential
                                    information. If you have any questions about the before-mentioned, have doubts about
                                    the originality, please contact</span>
                                <a href="mailto:request@CSIbizInfo.com" class="amail-style">request@CSIbizInfo.com.</a>
                                <br />
                                <br />
                                <h2 class="question">Miscellaneous</h2>
                                <br />
                                <span>
                                    This Agreement shall be treated as though it were executed and performed in Dallas,
                                    Terxas, and shall be governed by and construed in accordance with the laws of the
                                    State of Texas (without regard to conflict of law principles). Any cause of action
                                    by you with respect to the Site (and/or any information, Documents, products or
                                    services related thereto) must be instituted within one (1) year after the cause of
                                    action arose or be forever waived and barred. The language in this Agreement shall
                                    be interpreted as to its fair meaning and not strictly for or against any party.
                                    This Agreement and all incorporated agreements and your information may be
                                    automatically assigned by us in our sole discretion to a third party in the event of
                                    an acquisition, sale or
                                    merger. Should any part of this Agreement be held invalid or unenforceable, that
                                    portion shall be construed consistent with applicable law and the remaining portions
                                    shall remain in full force and effect. To the extent that anything in or associated
                                    with the Site is in conflict or inconsistent with this Agreement, this Agreement
                                    shall take precedence. Our failure to enforce any provision of this Agreement shall
                                    not be deemed a waiver of such provision nor of the right to enforce such provision.
                                    Our rights under this Agreement shall survive any termination of this Agreement.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">Arbitration</h2>
                                <br />
                                <span>
                                    Any legal controversy or legal claim arising out of or relating to this Agreement or
                                    our services, excluding legal action taken by us to collect or recover damages for,
                                    or obtain any injunction relating to, Site operations, intellectual property, and
                                    our services, shall be settled solely by binding arbitration in accordance with the
                                    commercial arbitration rules of JAMS. Any such controversy or claim shall be
                                    arbitrated on an individual basis, and shall not be consolidated in any arbitration
                                    with any claim or controversy of any other party. The arbitration shall be conducted
                                    in San Francisco, California, and judgment on the arbitration award may be entered
                                    into any court having jurisdiction thereof. Either you or we may seek any interim or
                                    preliminary
                                    relief from a court of competent jurisdiction in Dallas, Texas necessary to protect
                                    the rights or property of you and us pending the completion of arbitration. Each
                                    party shall bear one-half of the arbitration fees and costs incurred through JAMS.
                                </span>
                                <br />
                                <br />
                                <h2 class="question">Force Majeure</h2>
                                <br />
                                <span>“CSIbizInfo” will not be liable for failure to perform any obligation under this
                                    agreement if such failure is caused by the occurrence of any unforeseen contingency
                                    or circumstances beyond the reasonable control of “CSIbizInfo”, including without
                                    limitation Internet outages, communications outages, fire, flood war or an act of
                                    God.</span>
                                <br />
                                <br />
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        showReport: {
            type: Boolean,
            default: false,
        },
 
   
    },
    data() {
        return {
            window: window,
       
        };
    },
    computed: {
        reportDialog: {
            get() {
                return this.showReport;
            },
            set(newValue) { },
        },
        companyName: {
            get() {
                return this.companynameen;
            },
            set(newValue) { },
        },
    },
    created() {
    },
    methods: {
        // 文件上传限制
    

        //关闭弹窗
        cancelDialog() {
            this.$emit('closeReportDialog', false);
        },



 
     
        //取消report
        cancelReport() {
            this.reportDialog = false;
        },
        //添加report表单


    },
};
</script>
<style scoped>
/*注册条件 */
.agreement_cont {
    width: 100%;
    max-height: 83vh;
    overflow: auto;
    padding: 3.571em 4rem;
    font-size: 1.2857em !important;
}

.answer-title-italic {
    color: #000;
    font-style: italic;
}

.answer-content {
    padding-left: 3.571rem;
}

.answer-title {
    color: #000;
}

.info1 {
    color: #172434;
    font-size: 1.2857rem;
    text-align: left;
    line-height: 1.5714rem;
    overflow: hidden;
}

.info1box {
    width: 60rem;
    line-height: 1.5714rem;
    color: #585d64;
    font-size: 1.2857rem;
    text-align: left;

    word-break: keep-all;
}

.question {
    color: #1290c9;
    font-size: 1.2857rem;
}

.amail-style {
    color: #1290c9;
    border-bottom: 1px solid #1290c9;
}

.answer-ul {}

.agreement_cont /deep/ .el-tabs__item {
    font-size: 1.2857rem;
    color: #022955;

}

.agreement_cont /deep/.el-tabs__item.is-active,
.agreement_cont /deep/.el-tabs__item:hover {
    color: #1290c9;
}

.agreement_cont /deep/.el-tabs__active-bar {
    background-color: #1290c9;
}

.shake {
    animation: shake 0.5s;
}

@keyframes shake {
    0% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    50% {
        transform: translateX(5px);
    }

    75% {
        transform: translateX(-5px);
    }

    100% {
        transform: translateX(0);
    }
}

.login-right {
    width: 52%;
    /* height: 100vh; */
    background-size: 100% 100%;
    background-position: center center;
}

.login-right-desc {
    width: 78%;
    height: 89%;
    margin: 5.5% 0 5.5% 7.2%;
    background-size: contain;
    background-position: center center;
}

.login-left-blue {
    width: 48%;
    height: 40%;
    background: #1290C9;
    opacity: 0.13;
    filter: blur(3.571em);
    position: absolute
}

.login-content {
    /* position: relative; */
    z-index: 9999;
    /* width: 65%; */
    width: 37.142rem;
    margin: auto;
    overflow: hidden;
    /* margin-top: 12%; */
    /* margin-top: 10%; */
    /* margin-top: -30%; */
}

.popTitle {
    height: 3.1428rem;
    width: 20rem;
    margin: auto;
    margin-top: 10% !important;
    cursor: pointer;

}

.popTitletwo {
    width: 100%;
    margin: auto;
    text-align: center;
}

.popTitletwo-text {
    font-size: 2.571rem;
    color: #1A2332;
    line-height: 2.857rem;
    font-family: 'DMSans Bold';

}

.popTitle-head {
    font-size: 1.2857rem;
    color: #1A2332;
    line-height: 1.4285rem;
    margin-top: 2.1428rem;
    margin-bottom: 0.714rem;
}

.popTitle-img {
    height: 6.07rem;
}

.popTitle img {
    width: 100%;
    height: 100%;
}

/* login-kuaijie */
.info1box {
    width: 100% !important;
}

.Quicklogin {
    text-align-last: center;
    margin: 2.857rem auto;
    color: #8497AB;
    font-size: 1.142857rem;
}

.fb-signin-button {
    text-align: center;
    margin-right: 0.714rem;
}

.Quicklogin::before,
.Quicklogin::after {
    content: '';
    position: absolute;
    top: 42%;
    width: 46%;
    height: 1px;
    background-color: #cccccc;
}

.Quicklogin::before {
    left: 0;
}

.Quicklogin::after {
    right: 0;
}

.Quicklogin-img {
    display: flex;
    justify-content: center;
    position: relative;
}

/* .Quicklogin-img img {
    height: 25px;
    width: 25px;
} */

.linkending {
    height: 2em !important;
    width: 2em !important;
}

.goolebg {
    background-color: #fff;
    color: #1A2332;
    font-size: 1.2857rem;
}

.google_img {
    width: 2.1428rem;
    height: 2.1428rem;
    margin-right: 0.714rem;
}

.apple_img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.357rem;
}

.mr20 {
    margin-right: 1.4285rem;
}

.account {
    font-size: 1.2857rem;
    color: #111111;
    text-align: center;
}



.forgot_img {
    margin-bottom: 3.928em
}

.forgot_img_box {
    width: 20rem;
    height: 3.1428rem;
}

.forgotDialog-box {
    width: 60%;
    /* width: 1130px; */
    margin: auto;
    background-color: #fff;
    padding: 6.85em 15%;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;

}

.account .forgot_txt {
    font-size: 1.2857rem;
}

@media (max-width: 1441px) {

    .Quicklogin::before,
    .Quicklogin::after {

        top: 41%;

    }
}

@media (max-width: 1080px) {

    .Quicklogin::before,
    .Quicklogin::after {

        top: 38.5%;

    }
}

.intensity {
    /* margin-top: -10px; */
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1.4285rem;
}

.log_login {
    height: 100%;
    overflow: auto;
}

.log_login .dialog_cont {
    flex: 1;
    height: 100%;
    overflow: hidden;
    background-color: #fff;

}

/deep/ .el-form-item__error {
    font-size: 1.142857rem;
    color: #F56B6B;
}



.g_id_signin {
    position: relative;
    top: 1rem;
    z-index: 99999999;
    left: 3rem;
    top: -4px;
    /* width: 100%; */
    opacity: 0.01;
    pointer-events:all
}
.S9gUrf-YoZ4jf {
    z-index: 99999;
}
.nsm7Bb-HzV7m-LgbsSe{
    background-color: transparent !important;
    border: none !important;
}
</style>
